import Vue from 'vue'

const initialState = () => ({
    isShowingMsg: false
});

export const Toasts = {
    namespaced: true,
    state: initialState,
    mutations: {

    },
    actions: {
        /*
        * @param {String}  title - Title of toast
        * @param {String}  message - Message of toast
        * @param {('primary'|'secondary'|'danger'|'warning'|'success'|'info'))}  type - Type of allowed alerts status
        * @param {Number}  type - Delay after hide toast
        * */
        addToast(commit, {title, message, type, noAutoHide = false, delay = 5000}){
            const vm = new Vue();
            console.log("Adding toast");
            vm.$bvToast.toast(message, {
                title: title,
                noAutoHide: noAutoHide,
                autoHideDelay: delay,
                variant: type,
                appendToast: false,
                solid: true
            });
        }
    },
    getters: {
    }
};
